import { Button, Text } from '@payaca/ambrosia';
import { FunctionComponent, useCallback, type JSX } from 'react';
import { useHistory } from 'react-router-dom';

import ForgotPasswordForm from '@/ui/components/forgotPasswordForm/ForgotPasswordForm';

import './ForgotPasswordPage.sass';

const ForgotPasswordPage: FunctionComponent = (): JSX.Element => {
  const history = useHistory();

  const goToLoginPage = useCallback(() => {
    history.push('/login');
  }, [history]);

  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-col gap-4">
        <h1 className="mb-0 text-4xl font-bold">Reset your password</h1>
        <Text colour="muted">
          Enter the email address you used to create your account, and
          we&apos;ll send you instructions to reset your password.
        </Text>
      </div>
      <ForgotPasswordForm />
      <Text as="div">
        Remembered it?{' '}
        <Button onClick={goToLoginPage} variant="link">
          Log in
        </Button>
      </Text>
    </div>
  );
};

export default ForgotPasswordPage;
